import React, { useState } from 'react';
import FileDownload from '../ActionsTemplate/FileDownload';
import PrintFile from '../ActionsTemplate/PrintFile';
import MenuIcon from '../../../grid/MenuIcon';
import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';
import { FileSharingClientDetailsModal } from 'components/FileSharing/FileSharingClientDetailsModal';
import GlobalTooltip from 'components/GlobalTooltip';
import { useUserDetailsContext } from 'context/userDetailsContext';

function GlobalActionsTemplate({ rowData, e, itemsRef, onDownloadComplete }) {
  const { isClientFileManager } = useFileManagerContext();
  const { checkSubPermission } = useUserDetailsContext();
  const [clientDetailsModalshow, setClientDetailsModalshow] = useState(false);

  const docTypeVal = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
  // const printFileFormats = ['image/png', 'application/pdf', docTypeVal];
  const printFileFormats = ['application/pdf'];

  return (
    <>
      <React.Fragment key={e.rowIndex}>
        <span className="p-column-title">Actions</span>

        <span style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
          {rowData.entry_type !== 'folder' && (
            <React.Fragment>
              {/* Copy Link */}
              {checkSubPermission('file_sharing_non_lawft') && !isClientFileManager && (
                <span role="button" onClick={() => setClientDetailsModalshow(true)}>
                  <GlobalTooltip tooltip="Copy Link" className="text-primary-main" style={{ marginRight: '7px' }} position="top">
                    <i className="bi bi-link-45deg" aria-hidden="true" />
                  </GlobalTooltip>
                </span>
              )}

              {/* Print */}
              {rowData?.file_type && printFileFormats?.includes(rowData?.file_type?.toLowerCase()) ? (
                <div style={{ display: 'inline-block', marginRight: '7px' }}>
                  <PrintFile rowData={rowData} />
                </div>
              ) : null}
            </React.Fragment>
          )}

          {/* Download */}
          <FileDownload rowData={rowData} onDownloadComplete={onDownloadComplete} />

          {!isClientFileManager ? (
            <MenuIcon item={rowData} index={e.rowIndex} itemsRef={itemsRef} onDownloadComplete={onDownloadComplete} />
          ) : null}
        </span>
      </React.Fragment>

      <FileSharingClientDetailsModal
        show={clientDetailsModalshow}
        setShow={setClientDetailsModalshow}
        onHide={() => setClientDetailsModalshow(false)}
        rowData={rowData}
      />
    </>
  );
}

export default GlobalActionsTemplate;
